import {
    ADD_CONTENT_TO_PLAYLIST,
    ADD_TRANSLATED_PLAYLIST,
    ADD_TRANSLATED_QUIZ,
    ADD_TRANSLATED_SECTION,
    ADD_TRANSLATED_VIDEO,
    CLEAR_HISTORY,
    HANDLE_PLAYLIST,
    NEXT_PLAYLIST_CONTENT,
    POP_FROM_HISTORY,
    PREVIOUS_PLAYLIST_CONTENT,
    PUSH_TO_HISTORY,
    RESET_TRAINING_PROGRAM,
    SET_ACTIVE_CONTENT,
    SET_ACTIVE_TRANSLATION,
    SET_IS_TRANSLATING,
    SET_NEXT_BUTTON_DISABLED,
    SET_SHOW_COMPLETION,
    SET_UPDATING_TRAINING_RESULT,
    SET_VIDEO_AUTOPLAY,
    SET_VIDEO_CC,
} from '../actionTypes'

const defaultState = {
    activeTranslation: null,
    contentIndex: 0,
    history: [],
    isTranslating: true,
    isUpdatingTrainingResult: false,
    lastAction: null,
    nextButtonDisabled: false,
    playlist: {},
    sectionIndex: 0,
    showCompletion: false,
    videoAutoPlay: false,
    videoCC: 0,
}

const trainingProgramReducer = (initState = defaultState, action) => {
    const state = {
        ...initState,
        lastAction: action.type,
    }

    switch (action.type) {
        case ADD_CONTENT_TO_PLAYLIST:
            return {
                ...state,
                playlist: {
                    ...state.playlist,
                    sections: state.playlist.sections.map((section, index) => {
                        if (action.sectionIndex === index) {
                            return {
                                ...section,
                                content: section.content.map((content, i) => {
                                    return action.contentIndex === i ? action.newContent : content
                                }),
                            }
                        } else {
                            return section
                        }
                    }),
                },
            }

        case ADD_TRANSLATED_PLAYLIST:
            return {
                ...state,
                playlist: {
                    ...state.playlist,
                    title: [...state.playlist.title, action.translation],
                },
            }

        case ADD_TRANSLATED_SECTION:
            return {
                ...state,
                playlist: {
                    ...state.playlist,
                    sections: state.playlist.sections.map((section, sectionIndex) => {
                        if (sectionIndex === action.sectionIndex) {
                            return {
                                content: section.content,
                                title: [
                                    ...state.playlist.sections[sectionIndex].title,
                                    action.translation,
                                ],
                            }
                        } else {
                            return section
                        }
                    }),
                },
            }

        case ADD_TRANSLATED_VIDEO:
            return {
                ...state,
                playlist: {
                    ...state.playlist,
                    sections: state.playlist.sections.map((section, sectionIndex) => {
                        if (sectionIndex === action.sectionIndex) {
                            return {
                                ...section,
                                content: section.content.map((content, contentIndex) => {
                                    if (contentIndex === action.contentIndex) {
                                        return {
                                            ...content,
                                            translations: [
                                                ...content.translations,
                                                action.translation,
                                            ],
                                        }
                                    } else {
                                        return content
                                    }
                                }),
                            }
                        } else {
                            return section
                        }
                    }),
                },
            }

        case ADD_TRANSLATED_QUIZ:
            return {
                ...state,
                playlist: {
                    ...state.playlist,
                    sections: state.playlist.sections.map((section, sectionIndex) => {
                        if (sectionIndex === action.sectionIndex) {
                            return {
                                title: section.title,
                                content: section.content.map((content, contentIndex) => {
                                    if (contentIndex === action.contentIndex) {
                                        return {
                                            ...content,
                                            translations: [
                                                ...content.translations,
                                                action.translation,
                                            ],
                                        }
                                    } else {
                                        return content
                                    }
                                }),
                            }
                        } else {
                            return section
                        }
                    }),
                },
            }

        case CLEAR_HISTORY:
            return {
                ...state,
                history: [],
            }

        case HANDLE_PLAYLIST:
            return {
                ...state,
                playlist: action.playlist,
            }

        case NEXT_PLAYLIST_CONTENT:
            return {
                ...state,
                contentIndex: state.contentIndex + 1,
            }

        case POP_FROM_HISTORY:
            // [sectionIndex, contentIndex]
            const indexes = state.history[state.history.length - 1].split(':')
            return {
                ...state,
                history: state.history.slice(0, -1),
                sectionIndex: parseInt(indexes[0]),
                contentIndex: parseInt(indexes[1]),
            }

        case PREVIOUS_PLAYLIST_CONTENT:
            if (state.contentIndex === 0) {
                if (state.sectionIndex === 0) return state
                const newSection = state.playlist.sections(state.sectionIndex - 1)
                return {
                    ...state,
                    contentIndex: newSection.length - 1,
                    sectionIndex: state.sectionIndex - 1,
                }
            } else {
                return {
                    ...state,
                    contentIndex: state.contentIndex - 1,
                }
            }

        case PUSH_TO_HISTORY:
            return {
                ...state,
                history: [...state.history, action.key],
            }

        case RESET_TRAINING_PROGRAM:
            return defaultState

        case SET_ACTIVE_CONTENT:
            return {
                ...state,
                contentIndex: action.contentIndex,
                sectionIndex: action.sectionIndex,
                showCompletion: false,
            }

        case SET_ACTIVE_TRANSLATION:
            return {
                ...state,
                activeTranslation: action.translation,
            }

        case SET_NEXT_BUTTON_DISABLED:
            return {
                ...state,
                nextButtonDisabled: action.bool,
            }

        case SET_IS_TRANSLATING:
            return {
                ...state,
                isTranslating: true,
            }

        case SET_SHOW_COMPLETION:
            return {
                ...state,
                showCompletion: action.bool,
            }

        case SET_UPDATING_TRAINING_RESULT:
            return {
                ...state,
                isUpdatingTrainingResult: action.bool,
            }

        case SET_VIDEO_AUTOPLAY:
            return {
                ...state,
                videoAutoPlay: action.bool,
            }

        case SET_VIDEO_CC:
            return {
                ...state,
                videoCC: action.bool,
            }

        default:
            return state
    }
}

export default trainingProgramReducer
